import React, { useState } from 'react';
import UserJourney from 'modules/ReportModule/components/UserJourney';
import UserJourneyFilterForm from 'modules/ReportModule/drawers/components/UserJourneyFilterForm';
import { Divider, Popover, Badge, Button } from 'antd';
import Icon from '@mdi/react';
import useQueryParams from 'hooks/useQueryParams';
import { mdiFilterOutline } from '@mdi/js';
import EventDetailsPanel from './components/EventDetailsPanel';

const ActivityCard = () => {
  const { searchParams } = useQueryParams();
  const { user_id, event_id, session_id, ad_ids, adset_ids, campaign_ids } = searchParams;

  const [popoverOpen, setPopoverOpen] = useState(false);

  const activeFilterCount = [user_id, event_id, session_id, ad_ids, adset_ids, campaign_ids].filter(
    Boolean
  ).length;

  return (
    <div className='w-full h-full bg-white rounded-b-lg md:h-[calc(100vh-190px)]'>
      <div className='grid w-full h-full overflow-hidden md:grid-cols-5'>
        <div
          className='md:col-span-2 relative h-full overflow-x-hidden overflow-y-auto md:h-full'
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 0px 9px 0px',
          }}
        >
          <div className='h-fit sticky top-0 bg-white z-[99]'>
            <Popover
              placement='bottomRight'
              className='m-1 ml-auto'
              mouseLeaveDelay={0.7}
              trigger='click'
              open={popoverOpen}
              onOpenChange={setPopoverOpen}
              content={
                <div className='sm:w-72 w-full'>
                  <UserJourneyFilterForm />
                </div>
              }
            >
              <Badge
                offset={[-8, 8]}
                size='small'
                count={activeFilterCount}
                className='flex m-1 ml-auto'
              >
                <Button
                  size='large'
                  type={!popoverOpen && 'text'}
                  icon={<Icon path={mdiFilterOutline} size={0.8} />}
                />
              </Badge>
            </Popover>
            <Divider className='m-0' />
          </div>
          <div className='my-4'>
            <UserJourney className='col-span-1 mt-10' trigger='click' />
          </div>
        </div>
        <div className='md:col-span-3 md:h-[calc(100vh-190px)] h-full '>
          <EventDetailsPanel />
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;
